import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";
import { DropdownMenuSeparator } from "@elaniintc/goes-design-system/ui";
import { NavLink } from "react-router";

interface EllipsisDropdownProps {
  entity: string;
  id: string;
  onDuplicate?: (id: string) => void;
  onApproved?: (id: string) => void;
  onSelect: () => void;
  status: string;
  vacio: boolean;
  onDeactivate: () => void;
  onActivate: () => void;
}
export default function EllipsisDropdown({
  entity,
  id,
  onDuplicate,
  onSelect,
  status,
  vacio,
  onDeactivate,
  onActivate,
}: EllipsisDropdownProps) {
  const { hasPermission } = useAuthorization();
  const canEdit = hasPermission(Permissions.processes.update);
  const canCreate = hasPermission(Permissions.processes.create);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xs" className="size-8 cursor-pointer">
          <Icon type="far" name="ellipsis-vertical" className="text-current" />
          <span className="sr-only">
            Acciones para {entity} {id}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[222px] min-w-56 rounded-lg border-neutral text-body font-normal p-2 font-geist"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
            }}
            asChild
          >
            <NavLink to={`/plantillas/documentos/${id}`} className="w-full">
              Ver plantilla
            </NavLink>
          </DropdownMenuItem>
          {canEdit && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onSelect();
              }}
            >
              Editar detalles
            </DropdownMenuItem>
          )}
          {canCreate && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onDuplicate?.(id);
              }}
            >
              Duplicar plantilla
            </DropdownMenuItem>
          )}
          {status === "active" && (
            <>
              <DropdownMenuSeparator className="h-[1px] bg-[#B7C0CC] m-3" />
              <DropdownMenuItem
                className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer text-danger"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeactivate();
                }}
              >
                Desactivar plantilla
              </DropdownMenuItem>
            </>
          )}
          {status !== "active" && !vacio && (
            <>
              <DropdownMenuSeparator className="h-[1px] bg-[#B7C0CC] m-3" />
              <DropdownMenuItem
                className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onActivate();
                }}
              >
                Activar plantilla
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
